import Shell from "@/pages/Shell";
import { Seo } from "@/components/Seo";
import { About } from "@/components/About";
import { Prophetic } from "@/components/Prophetic";
import { Beliefs } from "@/components/Beliefs";

export default function AboutPage() {
  return (
    <Shell>
      <Seo
        title="About Charles McKuhn — Apostle & Prophetic Intercessor"
        description="The biography of Apostle Charles A. McKuhn Jr. — prophetic intercessor, author and community leader. His call to ministry, milestones, and the mantle he carries under the unction of the Holy Ghost."
        path="/about"
      />
      <h1 className="sr-only">About Charles McKuhn — Apostle & Prophetic Intercessor</h1>
      <About />
      <Prophetic />
      <Beliefs />
    </Shell>
  );
}
